import {
  BaseElementProperties,
  BaseFieldProperties,
  ConfigurationOrFieldProperties,
  ElementPropertiesMap,
  RecordTypeProperties,
} from './documentation';

// Salesforce configurations
// TODO SWEEP-8247 or SWEEP-8083 - move this to a general file, e.g salesforce.ts
//  in shared-with-client (assuming FE are using them), as these are not parser-only consts
export const PATH_ASSISTANT = 'PathAssistant';
export const VALIDATION_RULE = 'ValidationRule';
export const APPROVAL_PROCESS = 'ApprovalProcess';
export const WORKFLOW_RULE = 'WorkflowRule';
export const FLOW = 'Flow';
export const APEX_CLASS = 'ApexClass';
export const FIELD = 'Field';
export const PROCESS_BUILDER_FLOW = 'ProcessBuilderFlow';
export const LAYOUT = 'Layout';
export const APEX_TRIGGER = 'ApexTrigger';
export const EMAIL_TEMPLATE = 'EmailTemplate';
export const REPORT = 'Report';
export const RECORD_TYPE = 'RecordType';
export const OBJECT = 'Object';
export const CUSTOM_LABEL = 'CustomLabel';

export type Attributions = string[];

export interface FieldParserProperties extends BaseFieldProperties {
  picklistValues?: { name: string; label: string; attributions?: Attributions }[];
}

export interface FieldParserPropertiesWithUsage extends FieldParserProperties {
  usage?: number;
}

export interface RecordTypeParserProperties extends RecordTypeProperties {
  attributions?: Attributions;
}

export type RelatedElement = ConfigurationOrFieldProperties & {
  relatedObjects: string[];
};

export interface ParsedData {
  objectElements: ConfigurationOrFieldProperties[];
  relatedElements: RelatedElement[];
}

export interface ParsedObjectProperties {
  name: string;
  favorite: boolean;
}

export type ParsedRelatedElementsByType = {
  [type: string]: ConfigurationOrFieldProperties[];
};

type ElementArraysByType = {
  [K in keyof ElementPropertiesMap]?: ElementPropertiesMap[K][];
};

// Union of all possible array element types
type AllElementArrayTypes =
  | ElementArraysByType[keyof ElementArraysByType]
  | FieldParserPropertiesWithUsage[]
  | RecordTypeParserProperties[]
  | BaseElementProperties[];

// Base type without index signature
type ParsedObjectElementsKnown = Omit<ElementArraysByType, typeof FIELD | typeof RECORD_TYPE> & {
  [FIELD]?: FieldParserPropertiesWithUsage[];
  [RECORD_TYPE]?: RecordTypeParserProperties[];
};

export type ParsedObjectElementsByType = ParsedObjectElementsKnown & {
  [type: string]: AllElementArrayTypes;
};

export type ObjectParsedDataByType = ParsedObjectProperties & {
  objectElements: ParsedObjectElementsByType;
  relatedElements: ParsedRelatedElementsByType;
};

// TODO SWEEP-8247 - change to NaclFieldType once we fix the issue with NaclFieldType in shared-with-client
//  should change in the input and in the array (equal NaclFieldType.MULTI_PICKLIST and NaclFieldType.PICKLIST)
export function isNaclPicklistField(fieldType: string): boolean {
  return ['Picklist', 'MultiselectPicklist'].includes(fieldType);
}
